import { createReducer } from "@reduxjs/toolkit";
import CONSTANTS from "./CONSTANTS";
import authConstants from "../auth/CONSTANTS";

export const initState = {
  timerTime_Global: false,
  benefitsList: [],
  policiesList: [],
  myDoctorObj: undefined,
  myManagerObj: undefined,
  canChangeDoc: undefined,
  plannedVisitDoctorList: undefined,

  changePassword: false,
  mainPersonalInfo: {},
  isnuranceProductsList: [],
  remunartionsList: undefined,

  plannedVisitServiceCenterList: undefined,
  appealsList: undefined,

  //////////////////
  updateCounter: 0,
  deleteReservationSuccess: false,
  mainFindChildren: {},
  mainAddedChildren: [],
  mainAddChild: false,
  mainCheckChild: undefined,
  insurerMobile: "",
  OTPSended: false,

  userChanged: false,
  openUserModal: false,

  teqnicalMessages: null,
  resevationDocsSentSuccess: undefined,
  riskStatus: undefined,
  notifications: undefined,
  outOfOffice: null,

  showConsultationPopup: false,
  gridSizeValidationMain: true,
  requestLoadingMain: {
    loading: false,
    success: null,
  },
  policyId: "",
  extendedAppeal: false,
  scrollId: undefined,
};

const reducer = createReducer(initState, (builder) =>
  builder
    .addCase(authConstants.RESET_ALL, () => initState)
    .addCase(authConstants.LOGOUT_USER, () => initState)

    .addCase(CONSTANTS.SET_LOGIN_SEND_OTP_TO_USER, (state, action) => {
      state.timerTime_Global = action.payload;
    })
    .addCase(CONSTANTS.SET_MAIN_ACTIVE_BENEFITS, (state, action) => {
      state.benefitsList = action.payload;
    })
    .addCase(CONSTANTS.SET_MAIN_MY_POLICIES, (state, action) => {
      state.policiesList = action.payload;
    })
    .addCase(CONSTANTS.SET_MAIN_MY_DOCTOR, (state, action) => {
      state.myDoctorObj = action.payload;
    })
    .addCase(CONSTANTS.SET_MAIN_MY_MANAGER_BYPOLICYID, (state, action) => {
      state.myManagerObj = action.payload;
    })
    .addCase(CONSTANTS.SET_MAIN_PLANNED_VISITS_DOCTOR, (state, action) => {
      state.plannedVisitDoctorList = action.payload;
    })
    .addCase(
      CONSTANTS.SET_MAIN_PLANNED_VISITS_SERVICE_CENTER,
      (state, action) => {
        state.plannedVisitServiceCenterList = action.payload;
      }
    )
    .addCase(CONSTANTS.SET_MAIN_CHANGE_PASSWORD, (state, action) => {
      state.changePassword = action.payload;
    })
    .addCase(CONSTANTS.SET_MAIN_PERSONALINFO, (state, action) => {
      state.mainPersonalInfo = action.payload;
    })
    .addCase(CONSTANTS.SET_MAIN_INSURANCE_PRODUCTS_BY_USER, (state, action) => {
      state.isnuranceProductsList = action.payload;
    })
    .addCase(CONSTANTS.SET_MAIN_REMUNERATIONS_DASHBOARD, (state, action) => {
      state.remunartionsList = action.payload;
    })
    .addCase(CONSTANTS.SET_MAIN_DASHBOARD_APPEALS, (state, action) => {
      state.appealsList = action.payload;
    })
    .addCase(CONSTANTS.SET_MAIN_UPDATE_COUNTER, (state, action) => {
      state.updateCounter++;
    })
    .addCase(CONSTANTS.SET_MAIN_DELETE_RESERVATION, (state, action) => {
      state.deleteReservationSuccess = action.payload;
    })

    .addCase(CONSTANTS.SET_FIND_CHILDREN, (state, action) => {
      state.mainFindChildren = action.payload;
    })
    .addCase(CONSTANTS.SET_ADDED_CHILDREN, (state, action) => {
      state.mainAddedChildren = action.payload;
    })
    .addCase(CONSTANTS.SET_ADD_CHILD, (state, action) => {
      state.mainAddChild = action.payload;
    })
    .addCase(CONSTANTS.SET_CHECK_CHILD, (state, action) => {
      state.mainCheckChild = action.payload;
    })
    .addCase(CONSTANTS.SET_INSURER_MOBILE, (state, action) => {
      state.insurerMobile = action.payload;
    })
    .addCase(CONSTANTS.SET_SEND_OTP_INSURER, (state, action) => {
      state.OTPSended = action.payload;
    })
    .addCase(CONSTANTS.SET_SWITCH_USER, (state, action) => {
      state.userChanged = action.payload;
    })
    .addCase(CONSTANTS.SET_MAIN_OPEN_USER_MODAL, (state, action) => {
      state.openUserModal = action.payload;
    })
    .addCase(CONSTANTS.SET_MAIN_TECHICAL_MESSAGE, (state, action) => {
      state.teqnicalMessages = action.payload;
    })
    .addCase(CONSTANTS.SET_MAIN_ADD_RESERVATION_DOCUMENTS, (state, action) => {
      state.resevationDocsSentSuccess = action.payload;
    })
    .addCase(CONSTANTS.SET_MAIN_QUESTION_STATUS, (state, action) => {
      state.riskStatus = action.payload;
    })
    .addCase(CONSTANTS.SET_DOCTORS_CAN_CHANGE_PERSONAL_DOC, (state, action) => {
      state.canChangeDoc = action.payload;
    })
    .addCase(CONSTANTS.SET_UPDATE_PLANNED_VISITS_DOCTOR, (state, action) => {
      state.plannedVisitDoctorList = undefined;
    })
    .addCase(CONSTANTS.SET_NOTIFICATIONS_MAIN, (state, action) => {
      state.notifications = action.payload;
    })
    .addCase(CONSTANTS.GET_MAIN_IS_OUT_OF_OFFICE, (state, action) => {
      state.outOfOffice = action.payload;
    })
    .addCase(CONSTANTS.SET_SHOW_SPECIALIST_POPUP, (state, action) => {
      state.showConsultationPopup = action.payload;
    })
    .addCase(
      CONSTANTS.SET_COMPENSATIONS_REQUEST_LOADING_MAIN,
      (state, action) => {
        state.requestLoadingMain = action.payload;
      }
    )
    .addCase(CONSTANTS.SET_GRID_SIZE_VALIDATE_MAIN, (state, action) => {
      state.gridSizeValidationMain = action.payload;
    })
    .addCase(CONSTANTS.SET_POLICY_ID, (state, action) => {
      state.policyId = action.payload;
    })
    .addCase(CONSTANTS.SET_EXTEND_APPEAL, (state, action) => {
      state.extendedAppeal = action.payload;
    })
    .addCase(CONSTANTS.SET_SCROLL_ID, (state, action) => {
      state.scrollId = action.payload;
    })
);

export default reducer;
